import{ updatetheme,themedata }  from '../../../../store/theme_data';
import { useSelector } from "react-redux";
import { useEffect,useState } from 'react';
import dayjs from 'dayjs';
import "./Cardwidgetnewjson.css";

export default function Cardwidgetnewjson(props){
    const theme = useSelector((state) => state.themedata.theme)
    const tagaliascollectionvaluesnewjson = useSelector((state) => state.mainpagedata.tagaliascollectionvaluesnewjson);
    const tagcollectionvaluesnewjson = useSelector((state) => state.mainpagedata.tagcollectionvaluesnewjson);
    const [optionsmin, setOptionsMin] = useState(0);
    const [optionsmax, setOptionsMax] = useState(0);
    const [optionsminwithoutrounding, setOptionsMinwithoutrounding] = useState(0);
    const [optionsmaxwithoutrounding, setOptionsMaxwithoutrounding] = useState(0);
    const [optionstimemin, setOptionsTimeMin] = useState(0);
    const [optionstimemax, setOptionsTimeMax] = useState(0);
    const [widgetnamedisplay, setWidgetName] = useState(0);
    const [tagAlias, setTagAlias] = useState('Data Point');
    useEffect(() => {
        const tagProperties = props.widgetprop?.props?.extended?.tagprops || [];
        var widgetname = props.widgetprop?.widgetname;
        tagProperties.forEach(tagvalueprops => {
            if (
                tagvalueprops &&
                tagvalueprops.tagid &&
                tagcollectionvaluesnewjson &&
                Object.prototype.hasOwnProperty.call(tagcollectionvaluesnewjson, tagvalueprops.tagid)
            ) {
                var nestedvalue = tagcollectionvaluesnewjson[tagvalueprops.tagid];
                var tagalias = tagaliascollectionvaluesnewjson ? tagaliascollectionvaluesnewjson[tagvalueprops.tagid] : '';
                var sum = 0.0;
                var min = 10000000000;
                var max = -9999999999;
                var mintime = 0.0;
                var maxtime = 0.0;
                var options = { timeZone: "Asia/Kolkata" };
                if (Array.isArray(nestedvalue)) {
                    for (var i = 0; i < nestedvalue.length; i++) {
                        const yVal = nestedvalue[i]?.y;
                        const xVal = nestedvalue[i]?.x;
                        if (typeof yVal === 'number' && yVal > max) {
                            max = yVal;
                            var currentmaxformatteddate = new Date(xVal);
                            var maxformatteddate = currentmaxformatteddate.toLocaleDateString('en-us', { ...options, day: "numeric", month: "short", year: "numeric", hour: "numeric", minute: "numeric", second: "numeric" });
                            maxtime = maxformatteddate;
                        }
                        if (typeof yVal === 'number' && yVal < min) {
                            min = yVal;
                            var currentminformatteddate = new Date(xVal);
                            var minformatteddate = currentminformatteddate.toLocaleDateString('en-us', { ...options, day: "numeric", month: "short", year: "numeric", hour: "numeric", minute: "numeric", second: "numeric" });
                            mintime = minformatteddate;
                        }
                    }
                }
                // Handle max
                if (max === -9999999999) {
                    setOptionsMaxwithoutrounding("No Data");
                    max = "No Data";
                    maxtime = "No Data";
                } else if (typeof max === 'number' && !isNaN(max)) {
                    max = max.toFixed(2);
                    setOptionsMaxwithoutrounding(max);
                    
                } else {
                    setOptionsMaxwithoutrounding(max);
                }
                // Handle min
                if (min === 10000000000) {
                    setOptionsMinwithoutrounding("No Data");
                    min = "No Data";
                    mintime = "No Data";
                } else if (typeof min === 'number' && !isNaN(min)) {
                    min = min.toFixed(2);
                    setOptionsMinwithoutrounding(min);
                } else {
                    setOptionsMinwithoutrounding(min);
                }
                setOptionsMin(min);
                setOptionsMax(max);
                setOptionsTimeMin(mintime);
                setOptionsTimeMax(maxtime);
                setTagAlias(tagalias);
            }
        });
    }, [props.widgetprop, tagcollectionvaluesnewjson]);

    return(
        <>
            {/* Minimum Section */}
            <div style={{ width: "100%", display: "flex", flexDirection: "row", 
                        paddingTop: "60px", alignItems: 'baseline', 
                        paddingRight: "20px",paddingLeft: "20px", boxSizing: "border-box" }}>
                <div style={{ color: theme === 'light' ? "#3C3C3C" : "#FFFFFF", 
                            fontFamily: "Roboto", fontSize: "18px", fontWeight: 400 }}>
                    Minimum <span style={{fontSize:"10px",marginLeft:"3px"}}>{"(<=2 decimals)"}</span>
                </div>
                <div style={{ flexGrow: 1 }}></div> {/* Spacer */}
                <div className="tooltip" style={{ color: theme === 'light' ? "#3C3C3C" : "#FFFFFF", 
                            fontFamily: "Roboto", fontSize: "24px", fontWeight: 400, 
                            textAlign: "right", minWidth: "80px", textOverflow: "ellipsis" }}>
                    {optionsmin}
                    <span className="tooltiptext">{tagAlias +":"+optionsminwithoutrounding}</span>
                </div>
            </div>


            <div style={{ width: "100%", color: theme === 'light' ? "#3C3C3C" : "#C1C1C1", 
                        fontFamily: "Roboto", fontSize: "12px", fontWeight: 400, 
                        textAlign: "right", minWidth: "80px", paddingRight: "20px",boxSizing: "border-box", textOverflow: "ellipsis"}}>
                {optionstimemin}
            </div>


            {/* Maximum Section */}
            <div style={{ width: "100%", display: "flex", flexDirection: "row", 
                        paddingTop: "50px", alignItems: 'baseline', 
                        paddingRight: "20px",paddingLeft: "20px", boxSizing: "border-box" }}>
                <div style={{ color: theme === 'light' ? "#3C3C3C" : "#FFFFFF", 
                            fontFamily: "Roboto", fontSize: "18px", fontWeight: 400, }}>
                    Maximum<span style={{fontSize:"10px",marginLeft:"3px"}}>{"(<=2 decimals)"}</span>
                </div>
                <div style={{ flexGrow: 1 }}></div> {/* Spacer */}
                <div className="tooltip" style={{ color: theme === 'light' ? "#3C3C3C" : "#FFFFFF", 
                            fontFamily: "Roboto", fontSize: "24px", fontWeight: 400, 
                            textAlign: "right", minWidth: "80px", textOverflow: "ellipsis" }}>
                    {optionsmax}
                    <span className="tooltiptext">{tagAlias +":"+optionsmaxwithoutrounding}</span>
                </div>
            </div>


            <div style={{ width: "100%", color: theme === 'light' ? "#3C3C3C" : "#C1C1C1", 
                        fontFamily: "Roboto", fontSize: "12px", fontWeight: 400, 
                        textAlign: "right", minWidth: "80px", paddingRight: "20px",boxSizing: "border-box",textOverflow: "ellipsis"  }}>
                {optionstimemax}
            </div>
        </>
      
    )
}

  {/*<>
            <div>
                <div style={{width:"100%",display:"flex", flexDirection:"row", paddingTop:"60px",alignItems:'baseline',marginLeft:"20px",marginRight:"20px", boxSizing:"border-box"}}>
                    <div style={{color:theme=='light'?"#3C3C3C":"#FFFFFF", fontFamily:"Roboto", fontSize:"14px",fontWeight:400}}>Minimum</div>
                    <div style={{flexGrow:1}}></div>
                    <div style={{color:theme=='light'?"#3C3C3C":"#FFFFFF", fontFamily:"Roboto", fontSize:"24px",fontWeight:400,}}>{optionsmin}</div>
                </div>
                
                <div style={{width:"100%",color:theme=='light'?"#3C3C3C":"#C1C1C1", fontFamily:"Roboto", fontSize:"12px",fontWeight:400}}>{optionstimemin}</div>
            </div>
            

            <div style={{position:"inline-flex",display:"flex", flexDirection:"row", paddingTop:"40px",alignItems:'baseline',paddingLeft:"20px",paddingTop:"50px"}}>
                <div style={{color:theme=='light'?"#3C3C3C":"#FFFFFF", fontFamily:"Roboto", fontSize:"14px",fontWeight:400}}>Maximum</div>
                <div style={{color:theme=='light'?"#3C3C3C":"#FFFFFF", fontFamily:"Roboto", fontSize:"24px",fontWeight:400,paddingLeft:"206px"}}>{optionsmax}</div>
            </div>
            <div style={{color:theme=='light'?"#3C3C3C":"#C1C1C1", fontFamily:"Roboto", fontSize:"12px",fontWeight:400,paddingLeft:"235px"}}>{optionstimemax}</div>
        </>*/}